<template>
    <div class="user_profiles_video">
        <skeleton-screen-card v-if="!isCloseSkeletonScreen" :data="2" />
        <div v-if="isCloseSkeletonScreen">
            <div v-if="videoList.length">
                <dl
                    class="profiles_video_item"
                    v-for="(video, index) in videoList"
                    :key="index"
                    @click.stop.prevent="handleClickVideoDetail(video)"
                >
                    <dt class="v_cover">
                        <img :src="video.v_cover" v-if="video.v_cover" />
                        <div class="no_img" v-else-if="!video.v_cover">爱股票</div>
                        <div class="play_btn">
                            <img :src="require('@/assets/images/icon-play-btn@2x.png')" alt />
                        </div>
                    </dt>
                    <dd class="v_detail">
                        <h4 class="title_short">{{ video.title_short }}</h4>
                        <p class="v_num">
                            <span>{{ video.v_num }}个视频</span>
                            <span>播放量：{{ video.play_num }}</span>
                        </p>
                        <div v-if="video.is_free === '1'" class="free_video">免费课程</div>
                        <div v-if="video.is_free !== '1'" class="no_free_video">
                            <div class="discount" v-if="video.price_intro">{{ video.price_intro }}</div>
                            <div v-if="video.vip_unshared === 'no'" class="no_free_price">
                                <p class="discount_price">￥{{ video.sale_price }}</p>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
            <no-result v-if="!videoList.length" title="暂无视频~"></no-result>
            <no-data msg="已经到底了~" v-if="videoList.length && !hasMore"></no-data>
            <loading-dom
                class="loadbox"
                loadType="small"
                :title="'正在加载中...'"
                v-if="videoList.length && listLoading"
            ></loading-dom>
        </div>
    </div>
</template>
<script>
import userHomeApi from "@/api/user_home/index.js";

export default {
    name: "UserProfiles",
    components: {
        noData: () => import("@/components/userHome/components/noData.vue"),
        noResult: () => import("@/components/userHome/components/noResult.vue"),
        loadingDom: ()=> import("@/components/userHome/components/loading.vue"),
        skeletonScreenCard: () => import("@/components/userHome/components/skeletonScreen.vue")
    },
    computed: {
        userInfo() {
            return this.$store.state.userProfiles.userInfo;
        }
    },
    data() {
        return {
            videoList: [],
            live: {},
            user_id: parseInt(this.$route.params.id),
            isCloseSkeletonScreen: false,
            pullup: true,
            beforeScroll: true,
            hasMore: true,
            listLoading: true,
            page: 1,
            l_id: parseInt(this.$route.query.l_id) || 0,
            before: "",
            randomStr: Math.random()
                .toString(36)
                .slice(-4)
        };
    },
    created() {
        this.getVideoList();
    },
    methods: {
        columnListMore() {
            if (!this.hasMore) return;
            if (this.listLoading) return;
            this.getVideoList();
        },
        reloadList() {
            this.before = "";
            this.videoList = [];
            //获取用户全部数据
            this.getVideoList('close');
        },
        //老师个人主页  视频
        async getVideoList(type) {
            this.listLoading = true;
            let res = await userHomeApi.getVideoList({
                number: 10,
                before: this.before,
                l_id: this.l_id
            });
            if (res.data && res.data.length) {
                if (this.before) {
                    this.videoList = this.videoList.concat(res.data);
                } else {
                    this.videoList = res.data;
                }
                this.before = this.videoList[this.videoList.length - 1].display_order;
            } else {
                this.hasMore = false;
            }

            this.isCloseSkeletonScreen = true;
            this.listLoading = false;
            
            if(type) {
                this.$srH5CallNativeMethodApp('refresh_done',{})
            }
        },
        handleClickVideoDetail(info) {
            this.openNative("video_page", {
                id: info.id
            });
        },
        // 跳转APP页面
        openNative(type, query = {}) {
            let params = {
                kind: type, // 类型
            };

            // 同步传参
            params = {
                ...params,
                ...query
            }


            switch (type) {
                case "video_page": // 专辑详情页
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native', params)
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.recommend {
    position: fixed;
    overflow: auto;
    top: 48px;
    width: 100%;
    padding-bottom: 50px;
    bottom: 0;
    background-color: #f0f0f0;
}

.recommend-content {
    height: 100%;
    overflow: hidden;
}

.user_profiles_video {
    .profiles_video_item {
        background: $a-white;
        padding: 11.5px 12px;
        display: flex;

        position: relative;

        &::after {
            content: "";
            pointer-events: none;
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            transform-origin: 0 0;
            border-bottom: 1px solid $a-bordr-c;
            border-radius: 5px;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
        }

        .v_cover {
            width: 110px;
            height: 70px;
            flex-shrink: 0;
            position: relative;

            >img {
                width: 100%;
                height: 100%;
            }

            >.no_img {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #999999;
                background: #cccccc;
                font-size: 20px;
            }

            .play_btn {
                position: absolute;
                width: 30px;
                height: 30px;
                top: 50%;
                left: 50%;
                margin-left: -15px;
                margin-top: -15px;

                >img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .v_detail {
            height: 77px;
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: space-around;
            padding-left: 10px;
            box-sizing: border-box;

            >h4.title_short {
                font-size: 15px;
                color:$a-normal;
                line-height: 21px;
                font-weight: 400;
            }

            .v_num {
                font-size: 12px;
                color: #AFAFAF;
                line-height: 17px;
                margin-top: 4px;

                >span {
                    margin-right: 11px;
                }
            }

            //免费视频
            .free_video {
                color: #636363;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }

            //收费视频
            .no_free_video {
                height: 26px;
                display: flex;
                align-items: center;
                margin-top: 2px;

                .discount {
                    height: 21px;
                    color: #636363;
                    font-size: 12px;
                    line-height: 21px;
                    margin-right: 8px;
                }
                
                .no_free_price {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }

                .discount_price {
                    color: #636363;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                }
            }
        }
    }
}
</style>